// extracted by mini-css-extract-plugin
export default {"button":"_facaeb4e","disabled":"_fe4bffe8","primaryButton":"_af178582"};